if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return; /* v122 · 19-oct-2026: sin la foto en el modal no se rompe el zoom */
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        /* BM (19-ago-2026): en móvil el modal es un carrusel horizontal (CSS en
           bm-theme.css). Se salta directo a la foto tocada y se pinta el contador
           "n / N"; el scrollLeft de arriba (pensado para la foto ancha de escritorio)
           lo dejaría siempre en la primera. */
        if (window.matchMedia('(max-width: 749px)').matches) {
          const slides = Array.from(container.children).filter((el) => el.offsetWidth > 0);
          const idx = Math.max(0, slides.indexOf(activeMedia));
          container.scrollLeft = idx * container.clientWidth;
          let pill = this.querySelector('.bm-zoom-pos');
          if (!pill) {
            pill = document.createElement('div');
            pill.className = 'bm-zoom-pos';
            this.querySelector('.product-media-modal__dialog').appendChild(pill);
          }
          const pinta = () => {
            const w = container.clientWidth || 1;
            const i = Math.min(slides.length, Math.round(container.scrollLeft / w) + 1);
            pill.textContent = i + ' / ' + slides.length;
          };
          pinta();
          if (!this.bmScrollEnganchado) {
            this.bmScrollEnganchado = true;
            container.addEventListener('scroll', pinta, { passive: true });
          }
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
